import http from '../../utils/fetch';
export default {
    baseurl:'/api/swyl/v1/dict/bscDictInfo',
    page(q){
        return http({
            url: this.baseurl+'/selectPage',
            method: 'post',
            params: q
        });
    },
    selectList(q){
        return http({
            url: this.baseurl+'/selectList',
            method: 'post',
            params: q
        });
    },
    listbycategory(category) {
        return http({
            url: this.baseurl+'/listbycategory',
            method: 'post',
            params: {"category":category}
        });
    },
    listbycategoryanddes(category,des) {
        return http({
            url: this.baseurl+'/listbycategoryanddes',
            method: 'post',
            params: {"category":category,"des":des}
        });
    },
    listMdmbycategory(category) {
        return http({
            url: this.baseurl+'/listMdmbycategory',
            method: 'post',
            params: {"category":category}
        });
    },
    getAllDictList() {
        return http({
            url: this.baseurl+'/getAllDictList',
            method: 'post',
        });
    },
    getDictByCateCode(cate,code) {
        return http({
            url: this.baseurl+'/getDictByCateCode',
            method: 'post',
            params: {"category":cate,"code":code}
        });
    },
    getDictByCateName(cate,name) {
        return http({
            url: this.baseurl+'/getDictByCateName',
            method: 'post',
            params: {"category":cate,"name":name}
        });
    },
    save(f) {
        return http({
            url: this.baseurl+'/insert',
            method: 'post',
            params: f
        });
    },
    deleteById(f) {
        return http({
            url: this.baseurl+'/deleteById',
            method: 'post',
            params:{id:f}
        });
    },
    updateById(f) {
        return http({
            url: this.baseurl+'/updateById',
            method: 'post',
            params:f
        });
    },

    arealist(q){
        return http({
            url: '/api/swyl/v1/basic/bscAddr/selectList',
            method: 'post',
            params: q
        });
    },
    selNextBscAddressByName(data){
        return http({
            url: '/api/swyl/v1/basic/bscAddr/selNextBscAddressByName',
            method: 'post',
            data: data
        });
    },
    arealistLoud(q){
        return http({
            url: '/api/swyl/v1/basic/bscAddr/selectListLoud',
            method: 'post',
            params: q
        });
    },
    areaTreelist(q){
        return http({
            url: '/api/swyl/v1/basic/bscAddr/getAreaTree',
            method: 'post',
            params: q
        });
    },
    areaTreelistLoud(q){
        return http({
            url: '/api/swyl/v1/basic/bscAddr/getAreaTreeLoud',
            method: 'post',
            params: q
        });
    },
    getCity(q){
        return http({
            url: '/api/swyl/v1/basic/bscAddr/getCity',
            method: 'post',
            params: q
        });
    },

    selectShengshiList(q){
        return http({
            url: '/api/swyl/v1/basic/bscAddr/selectShengshiList',
            method: 'post',
            params: q
        });
    },

    selectFieldList(q){
        return http({
            url: '/api/swyl/v1/basic/bscAddr/selectFieldList',
            method: 'post',
            params: q
        });
    },

    selectDaQuList(q){
        return http({
            url: '/api/swyl/v1/basic/bscAddr/selectDaQuList',
            method: 'post',
            params: q
        });
    },

    selectQuYuList(daqu){
        return http({
            url: '/api/swyl/v1/basic/bscAddr/selectQuYuList',
            method: 'post',
            params: {'daqu':daqu}
        });
    },



}
